import { Box, Typography } from "@mui/material";

const BookingCard = ({ gymName, gymIcon, bookingTime, onClick, selected, noPointer }) => {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#1F222A",
        borderRadius: "12px",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "5px 10px",
        cursor: !selected && !noPointer ? "pointer" : "default",
        gap: "10px",
        transition: "border 0.3s, box-shadow 0.3s",
        //border: selected ? "2px solid #FF6401" : "2px solid rgba(255, 255, 255, 0)",
        minHeight: "90px",
        maxWidth: "700px",
      }}
      onClick={onClick}
    >
      <Box style={{ display: "flex", gap: "10px", justifyContent: "center", alignItems: "center" }}>
        <Box
          style={{
            backgroundColor: "#181A20",
            borderRadius: "8px",
            width: "80px",
            height: "80px",
            flexShrink: 0,
          }}
        >
          <img
            src={gymIcon}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
        <Box style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Typography
            style={{
              fontSize: "24px",
              fontFamily: "Urbanist",
              fontWeight: "bold",
              color: "rgba(255, 255, 255, 1)",
              lineHeight: "0.9",
            }}
          >
            {gymName}
          </Typography>
        </Box>
      </Box>

      <Typography
        style={{
          fontSize: "20px",
          fontFamily: "Urbanist",
          fontWeight: "bold",
          color: "rgba(255, 255, 255, 1)",
          textAlign: "center",
          lineHeight: "1.2",
          color: "#FF9700",
        }}
      >
        {bookingTime}
      </Typography>
    </Box>
  );
};

export default BookingCard;
